import { useMakeQuestionPrivateMutation } from './qna.gql.impl';

const useMakeQuestionPrivate = () => {
  const { mutate } = useMakeQuestionPrivateMutation();

  const makeQuestionPrivate = (questionId: string) => {
    return new Promise<boolean>((resolve, reject) => {
      mutate(
        {
          questionPid: questionId,
        },
        {
          onSuccess: () => {
            resolve(true);
          },
          onError: (error) => {
            reject(error);
          },
        }
      );
    });
  };

  return { makeQuestionPrivate };
};

export default useMakeQuestionPrivate;
